import { UbicationStateInterface } from '.';

function state(): UbicationStateInterface {
  return {
    ubications: [],
  };
}

export default state;
